export const getEncounterStatus = (encounter) => {
    const isStarted = Boolean(encounter === null || encounter === void 0 ? void 0 : encounter.startTime);
    const isCancelled = Boolean(encounter === null || encounter === void 0 ? void 0 : encounter.cancelTime);
    const isFinished = Boolean(encounter === null || encounter === void 0 ? void 0 : encounter.finishTime);
    const isInProgress = isStarted && !isFinished && !isCancelled;
    return {
        isStarted,
        isCancelled,
        isFinished,
        isInProgress,
        canStart: !isStarted && !isCancelled && !isFinished,
        canRestart: isCancelled,
        canFinish: isInProgress,
        canCancel: isInProgress,
    };
};
export const isLegacyEncounter = (value) => {
    return Boolean(value === 1);
};
